<template>
    <v-text-field
        v-model="search"
        :label="$t('message.Search')"
        append-icon="search"
        spellcheck="false"
        single-line
        hide-details
        clearable
        solo
        filled
        dense
        rounded
    />
</template>
<script>
export default {
    computed: {
        search: {
            get() {
                return this.$store.getters.getSearch;
            },
            set(val) {
                this.$store.commit("setSearch", val);
            },
        },
    },
    watch: {
        $route: {
            handler() {
                this.search = null;
            },
        },
    },
};
</script>
